import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";

export default function SiteFooter({ content, siteName = "Cuba Bella Café" }) {
    const { t, lang } = useI18n();
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="bg-black border-t border-gold/15 pt-16 pb-8">
            <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        {content?.logo_url && (
                            <img src={content.logo_url} alt={siteName} className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/30" />
                        )}
                        <div>
                            <div className="font-script text-gold text-xl leading-none">Habana</div>
                            <div className="font-serif text-2xl text-habana-cream">{siteName}</div>
                        </div>
                    </div>
                    <p className="mt-5 text-habana-cream/55 max-w-md leading-relaxed">
                        {lang === "es"
                            ? "El sabor de la isla y el alma habanera en cada visita. Café, ron, cocina y familia."
                            : "The island's flavor and Havana's soul in every visit. Coffee, rum, cuisine and family."}
                    </p>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.32em] text-gold mb-4">
                        {t("nav_menu")}
                    </div>
                    <ul className="space-y-2 text-habana-cream/70">
                        <li><a href="#hero" className="hover:text-gold transition-colors">{t("nav_home")}</a></li>
                        <li><a href="#menu" className="hover:text-gold transition-colors">{t("nav_menu")}</a></li>
                        <li><a href="#story" className="hover:text-gold transition-colors">{t("nav_story")}</a></li>
                        <li><a href="#gallery" className="hover:text-gold transition-colors">{t("nav_gallery")}</a></li>
                        <li><a href="#contact" className="hover:text-gold transition-colors">{t("nav_contact")}</a></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.32em] text-gold mb-4">
                        {t("nav_contact")}
                    </div>
                    <ul className="space-y-2 text-habana-cream/70">
                        <li>{content?.phone}</li>
                        {content?.phone2 && <li>{content.phone2}</li>}
                        <li>{content?.address}</li>
                        <li>{lang === "es" ? content?.hours_es : content?.hours_en}</li>
                        <li className="pt-2">
                            <Link to="/admin/login" className="text-gold/70 hover:text-gold text-sm underline-offset-4 hover:underline" data-testid="footer-admin-link">
                                {t("nav_admin")}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mx-auto max-w-7xl px-6 md:px-10 mt-12 pt-6 border-t border-gold/10 flex flex-col md:flex-row justify-between items-center gap-3">
                <div className="text-xs tracking-wider text-habana-cream/40">
                    © {year} {siteName} — {t("footer_rights")}
                </div>
                <div className="font-script text-gold text-lg">{t("made_with")}</div>
            </div>
        </footer>
    );
}
